import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=70e7ddba&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=70e7ddba&prod&lang=less&scoped=true"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=70e7ddba&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7ddba",
  null
  
)

export default component.exports